import moment from "moment";
import { DATE_FORMATS } from "../constants";

const toLocalDate = time => (time ? moment.utc(time).local().format(DATE_FORMATS.DATE) : '');

export default {
    toLocalDate
};